import React from 'react';
import { createStructuredSelector } from 'reselect';
import { connect } from 'react-redux';
import { makeSelectCollectionDetail } from '~/containers/CollectionPageDetail/selectors';
import I18nLink from '~/components/I18nLink';
import withI18next from '~/../hocs/_withI18next';
import config from '~/config';
import themeVariables from '~/shared/themeVariables';
import {
  makeSelectProfile,
  makeSelectIsAuthenticated,
} from '~/containers/AuthProvider/selectors';
import { USER_ROLES } from '~/utils/constants';
import Container from '~/components/Container';
import ACImage from '~/components/ACImage';

const HeroBanner = ({
  t,
  lng,
  isAuthenticated,
  profile,
  imageURL,
  title,
  subTitle,
  isExtraLicense,
  hiddenExplore,
  collectionDetail,
  responsive,
  altImage = 'slideshow image',
}) => {
  let creatorURL = '/';
  // TODO: REMOVE THIS COMMENT
  // if (config.isPhotoAC() || config.isSilhouetteAC()) {
  //   creatorURL = '/creator-profile/43626';
  // } else if (config.isIllustAC()) {
  //   creatorURL = '/creator-profile/6746';
  // } else if (config.isDesignAC()) {
  //   creatorURL = '/creator-profile/6744';
  // }

  return (
    <div className="hero-banner">
      <div className="slide-image">
        <ACImage
          src={imageURL}
          alt={altImage}
          priority
          placeholder={typeof imageURL === 'object' ? 'blur' : 'empty'}
        />
        <div className="overlay-blur" />
      </div>

      <div className="container-content">
        <Container>
          <h1 className="title-slider">{title}</h1>
          <h2 className="description-title">{subTitle}</h2>
        </Container>

        {!hiddenExplore &&
          (!isAuthenticated || profile.role === USER_ROLES.CREATOR) && (
            <I18nLink href={{ pathname: '/premium' }} shallow>
              <a className="explore-button" target="_blank" rel="noreferrer">
                {t('subcribe_now')}
              </a>
            </I18nLink>
          )}
      </div>
      <div
        className="photo-from-creator"
        dangerouslySetInnerHTML={{
          __html: isExtraLicense
            ? t('extra_license_from_creator_acworks', {
                creatorURL,
              })
            : t(`${config.getPrefixContent('from_creator')}`, {
                creatorName: 'ACworks',
                creatorURL,
                collectionName: collectionDetail.name
                  ? collectionDetail.name
                  : '',
              }),
        }}
      />
      <style jsx>
        {`
          .hero-banner {
            width: 100%;
            height: fit-content;
            position: relative;
          }
          .slide-image {
            position: relative;
            width: 100%;
            height: ${responsive ? '300px' : '468px'};
            background: rgba(233, 228, 228, 0.3);
            overflow: hidden;
          }
          .overlay-blur {
            position: absolute;
            top: 0;
            bottom: 0;
            left: 0;
            right: 0;
            width: 100%;
            background: rgba(0, 0, 0, 0.35);
          }
          .photo-from-creator {
            position: absolute;
            color: #fff;
            font-weight: normal;
            right: 16px;
            bottom: 16px;
            font-size: 16px;
          }
          // .photo-from-creator > a {
          //   color: #fff;
          //   text-decoration: underline;
          // }
          .photo-from-creator > a:hover {
            // color: #fff;
            text-decoration: underline !important;
            opacity: 0.8;
          }
          .container-content {
            position: absolute;
            top: 0;
            display: flex;
            flex-direction: column;
            justify-content: center;
            color: #fff;
            margin: 0 auto;
            text-align: center;
            align-items: center;
            width: 100%;
            height: 100%;
          }
          .title-slider {
            font-size: 56px;
            text-shadow: 0 0 1px rgba(0, 0, 0, 0.6);
            font-weight: 600;
            padding: 0;
            margin: 0;
          }
          .description-title {
            font-size: 24px;
            margin: 20px 0;
            text-shadow: 0 0 1px rgba(0, 0, 0, 0.6);
          }
          .explore-button {
            width: 135px;
            height: 44px;
            background: #cc0000;
            border-radius: 4px;
            font-weight: 600;
            font-size: 14px;
            text-transform: uppercase;
            color: #f8f9fa;
            display: flex;
            flex-direction: row;
            align-items: center;
            justify-content: center;
          }
          .explore-button:hover {
            background: #7a0000;
          }
          @media (max-width: ${themeVariables.breakpoints.desktopMedium
              .maxWidth}px) {
            .slide-image {
              height: ${responsive ? '300px' : '468px'};
            }
          }
          @media (max-width: ${themeVariables.breakpoints.tabletL.maxWidth}px) {
            .slide-image {
              height: ${responsive ? '300px' : '468px'};
            }
            .title-slider {
              font-size: ${responsive ? '48px' : ''};
            }
          }
          @media (max-width: ${themeVariables.breakpoints.tabletS.maxWidth}px) {
            .slide-image {
              height: ${responsive ? '300px' : '468px'};
            }
          }

          @media (max-width: ${themeVariables.breakpoints.mobile.maxWidth}px) {
            .title-slider {
              font-size: 32px;
            }
            .description-title {
              font-size: 18px;
            }
          }
        `}
      </style>
    </div>
  );
};

const mapStateToProps = createStructuredSelector({
  profile: makeSelectProfile(),
  isAuthenticated: makeSelectIsAuthenticated(),
  collectionDetail: makeSelectCollectionDetail(),
});

export default withI18next()(connect(mapStateToProps)(HeroBanner));
